module.exports = __webpack_public_path__ + "octopus.9eb1b1a919d314ca1d4b186f6a9383e7.hashedasset.svg";